<div class="login-body flex flex-column align-items-center justify-content-center">
	<div class="login-panel p-5 pt-6 p-fluid flex flex-column justify-content-center">
		<h4 class="font-bold">VERONA</h4>
		<span class="mb-4 line-height-3"
			>Welcome to the <span class="font-bold">Verona Community</span>,<br />
			where the magic happens, sign in to continue</span
		>

		<span class="p-input-icon-left mb-3">
			<i class="pi pi-user"></i>
			<input type="text" pInputText placeholder="Email Address" />
		</span>

		<span class="p-input-icon-left mb-6">
			<i class="pi pi-key"></i>
			<input type="password" pInputText placeholder="Password" />
		</span>

		<button type="button" pButton label="Sign In" [routerLink]="['/']"></button>
	</div>

	<span class="mt-4"
		>Don’t you have an account, <span class="font-bold cursor-pointer" [routerLink]="['/']">sign up</span></span
	>
</div>
